import React from 'react'
import SmmPic from '../../../images/social-media-banner.png'

const SmmBanner = () => {
    return (
        <>
            <div className="inner-page-bg">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="php-web-banner">
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-7">
                                        <img src={SmmPic} alt='Social Media' />
                                    </div>
                                    <div className="col-md-5">
                                        <div className="php-web-app">
                                            <h2>Social Media Marketing</h2>
                                            <h5>We would be happy to hear from you, Please fill in the form below or mail us your requirements on</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default SmmBanner